module.exports = __webpack_public_path__ + "img/dishi.9bc94031.jpg";